var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M13.775.811a1 1 0 1 1 1.414 1.414L9.414 8l5.775 5.775a1 1 0 0 1-1.414 1.414L8 9.414 2.225 15.19a1 1 0 0 1-1.414-1.414L6.586 8 .81 2.225A1 1 0 1 1 2.225.811L8 6.586z"
  })));
};
export default SvgCloseIcon;